<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    :fixed-header="true"
    item-key="idmodulo"
    class="elevation-2 table-acl-resposivo"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Cadastro de Módulos</v-toolbar-title>
        <v-spacer />
        <v-text-field
          class="mr-4"
          v-model="search"
          outlined
          dense
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog persistent v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Novo</v-btn>
          </template>
          <v-card>
            <v-card-title class="mb-7">{{ formTitle }}</v-card-title>
            <v-card-text class="d-flex align-center mb-6" style="min-height: 55vh">
              <v-container>
                <v-row>
                  <v-col class="pa-0" cols="12" xs="12">
                    <v-text-field
                      outlined
                      v-model="editedItem.descricao_modulo"
                      label="Nome Modulo*"
                      autofocus
                      :error-messages="nameErrors"
                      @input="$v.editedItem.descricao_modulo.$touch()"
                      @blur="$v.editedItem.descricao_modulo.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col class="pa-0" cols="12" xs="12">
                    <v-text-field
                      outlined
                      v-model="editedItem.src_modulo"
                      label="Nome Ícone*"
                      :error-messages="srcErrors"
                      :append-icon="editedItem.src_modulo"
                      @input="$v.editedItem.src_modulo.$touch()"
                      @blur="$v.editedItem.src_modulo.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.src_modulo="{ item }">
      <v-icon>{{ item.src_modulo }}</v-icon>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon title="Editar Módulo" class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon title="Remover Módulo" @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>
  </v-data-table>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import AclAPI from "./../../api/acl";

export default {
  name: "Acl",
  data: () => ({
    dialog: false,
    atualizar: 0,
    search: "",
    headers: [
      { text: "ID", value: "idmodulo", width: "80px", align: "center" },
      { text: "Módulo", align: "left", value: "descricao_modulo" },
      { text: "Ícone", value: "src_modulo", align: "center" },
      { text: "", value: "action", sortable: false, width: "100px", align: "center" },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      idmodulo: "",
      descricao_modulo: "",
      src_modulo: "",
    },
    defaultItem: {
      idmodulo: "",
      descricao_modulo: "",
      src_modulo: "",
    },
  }),

  validations: {
    editedItem: {
      descricao_modulo: {
        required,
      },
      src_modulo: {
        required,
      },
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.descricao_modulo.$dirty) return errors;
      !this.$v.editedItem.descricao_modulo.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    srcErrors() {
      const errors = [];
      if (!this.$v.editedItem.src_modulo.$dirty) return errors;
      !this.$v.editedItem.src_modulo.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Módulo" : "Editar Módulo";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      AclAPI.getModulos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.desserts = response.data.modulos;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch("loading/habilitarLoading", false);
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover o módulo?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delModulo(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};

                this.initialize();

                //atualizar aplicativos
                this.$emit("atualizarApp", (this.atualizar += 1));
              }
            })
            .catch(() => {
              this.Helpers.logout();
            }),
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.$v.$reset();
    },

    save() {
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.addModulo(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();

                //atualizar aplicativos
                this.$emit("atualizarApp", (this.atualizar += 1));
              }
            })
            .catch(() => {
              this.Helpers.logout();
            }),
        );

        this.close();
      }
    },
  },
};
</script>
